import React from "react";

export const LoadingState = () => (
  <div className="fixed bottom-10 right-10 z-[9999] flex items-center justify-center bg-white px-4 py-3 shadow-[0px_0px_20px_rgba(0,0,0,0.08)] rounded-lg">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div><h4 className="ml-2.5 font-medium text-[rgba(var(--primary-rgb)/100%)]">Loading</h4>
  </div>
);
